import { create } from "zustand";
import { PurchaseOrder } from "types";

type PurchaseOrderState = {
  rows: PurchaseOrder[];
  isLoading: boolean;
  setRows: (rows: PurchaseOrder[]) => void;
  upsertRow: (row: PurchaseOrder) => void;
  removeRow: (id: number | string) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
};

export const usePurchaseOrderStore = create<PurchaseOrderState>()((set) => ({
  rows: [],
  isLoading: false,
  setRows: (rows) => set({ rows: rows || [] }),
  upsertRow: (row) =>
    set((state) => {
      const exists = state.rows.find((item) => item.id === row.id);
      const rows = exists
        ? state.rows.map((item) =>
            item.id === row.id ? { ...item, ...row } : item,
          )
        : [row, ...state.rows];
      return { rows };
    }),
  removeRow: (id) =>
    set((state) => ({
      rows: state.rows.filter((item) => String(item.id) !== String(id)),
    })),
  setLoading: (loading) => set({ isLoading: loading }),
  reset: () => set({ rows: [], isLoading: false }),
}));
